import * as React from "react";
import { useState, useCallback } from "react";
import classNames from "classnames";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { DATATEST } from "constants/integration";

// prettier-ignore
interface IProps {
    poster?: string;
    className?: string;
    height?: string;
}

export const VideoPoster = ({ poster, className, height }: IProps) => {
    const [showFallback, setShowFallback] = useState(false);
    const handleFallback = useCallback(() => setShowFallback(true), []);

    const classes = useStyles({ height });
    return (
        <React.Fragment>
            {poster && !showFallback && (
                <img
                    className={classNames(classes.poster, className)}
                    src={poster}
                    alt="poster"
                    onError={handleFallback}
                    data-test={poster && DATATEST.PDP.VIDEO_POSTER}
                />
            )}
            {!(poster && !showFallback) && <div className={classNames(classes.poster, className, "fallback")} />}
        </React.Fragment>
    );
};

const useStyles = makeStyles({
    poster: ({ height }: any) => ({
        width: "100%",
        height: height ?? "100%",
        objectFit: "contain",
        "&.fallback": {
            background: "#e5e5e5",
        },
    }),
});

export default VideoPoster;
